<template>
    <div>
        <v-card class="pa-3 ma-3">
            <loader :loading="isloading"></loader>

            <v-toolbar flat color="#1d2735" dark>
                <v-icon class="white--text" style="font-size: 45px">
                    mdi-file-table-outline
                </v-icon>
                <pre><v-toolbar-title><h2>Lista de abonos</h2></v-toolbar-title></pre>
            </v-toolbar>
            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        fab
                        :to="'/'"
                        :loading="isloading"
                        :disabled="isloading"
                        color="blue"
                        class="mx-3 mt-2"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon class="white--text"
                            >mdi-arrow-left-bold-outline</v-icon
                        >
                    </v-btn>
                </template>
                <span>Volver</span>
            </v-tooltip>
            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        fab
                        to="/registrar-factura-devolucion"
                        :loading="isloading"
                        :disabled="isloading"
                        color="orange darken-1"
                        class="mt-2"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon class="white--text">mdi-plus-box</v-icon>
                    </v-btn>
                </template>
                <span>Nueva Factura</span>
            </v-tooltip>
            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        fab
                        @click="CambiarAnioModal()"
                        :loading="isloading"
                        :disabled="isloading"
                        color="blue"
                        class="mx-3 mt-2"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon class="white--text">mdi-calendar</v-icon>
                    </v-btn>
                </template>
                <span>Cambiar Año Fiscal</span>
            </v-tooltip>
            <!-- <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    @click="Exportar"
                    :loading="isloading"
                    :disabled="isloading"
                    color="green darken-1"
                    class="ml-3 mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-file-excel</v-icon>
                </v-btn>
            </template>
            <span>Exportar</span>
        </v-tooltip> -->

            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6" justify="center">
                        <FilterComponentVue
                            :headers="filter_headers"
                            v-model="filtros_prueba"
                        ></FilterComponentVue>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-card>
                            <v-card-text>
                                <h3>
                                    Total: {{ formatPrice(importe_total) }}€
                                </h3>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-data-table
                    dense
                    :server-items-length="totalFacturas"
                    :headers="headers"
                    :items="facturas"
                    :search="filtros_prueba.search"
                    :items-per-page="15"
                    item-key="id"
                    class="elevation-1"
                    :sort-by="['nro_anio_factura']"
                    :sort-desc="[true]"
                    @update:options="onOptionsUpdate"
                >
                    <template v-slot:item.fecha="{ item }">
                        {{ item.fecha | format_date }}
                    </template>
                    <template v-slot:item.url="{ item }">
                        <a :href="item.url" target="_blank">
                            <v-icon> mdi-file-pdf-box </v-icon>
                        </a>
                    </template>
                    <!-- <template v-slot:item.cliente_real.nombre_fiscal="{ item }">
                        <template v-if="item.cliente_real">
                            <template v-if="item.cliente_real.nombre_fiscal">{{
                                item.cliente_real.nombre_fiscal
                            }}</template>
                            <template v-else>{{
                                item.cliente_real.nombre
                            }}</template>
                        </template>
                    </template> -->
                    <template v-slot:item.total="{ item }">
                        {{ formatPrice(item.total) }}€
                    </template>
                    <template v-slot:item.facturada="{ item }">
                        <div
                            :style="`background-color:${
                                item.id_factura != null ? 'green' : 'red'
                            }`"
                            class="circle"
                        ></div>
                    </template>
                    <template v-slot:item.pagada="{ item }">
                        <div
                            :style="`background-color:${
                                item.esta_pagada == 1
                                    ? 'green'
                                    : item.esta_pagada == 0
                                    ? 'red'
                                    : item.esta_pagada == 2
                                    ? 'orange'
                                    : 'blue'
                            }`"
                            class="circle"
                        ></div>
                    </template>
                    <template v-slot:item.enviado="{ item }">
                        <div
                            :style="`background-color:${
                                item.enviado == 1 ? 'green' : 'red'
                            }`"
                            class="circle"
                        ></div>
                    </template>
                    <template v-slot:item.action="{ item, index }">
                        <v-icon
                            @click="
                                mail_dialog = true;
                                id_factura = item.id;
                                kit_seleccionado = item.kit;
                                email = item.email;
                            "
                            small
                            class="mr-2"
                            color="red"
                            style="font-size: 25px"
                            title="Enviar Email"
                            >mdi-email</v-icon
                        >
                        <!--  <v-icon
                        v-if="tipo != 2 && item.esta_pagada != 1"
                        @click="openModalIngreso(item)"
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="Generar Ingreso"
                        >mdi-cash</v-icon
                    >
                    <v-icon
                        v-else
                        small
                        class="mr-2"
                        style="font-size: 25px; width: 25px"
                        title="Generar Ingreso"
                    ></v-icon>
                    <v-icon
                        @click="openModalVenta(item)"
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="Generar Venta"
                        >mdi-cash-100</v-icon
                    > -->
                        <!-- <v-icon
                        v-if="tipo == 2"
                        @click="openModalCambio(item.id)"
                        small
                        class="mr-2"
                        style="font-size: 25px"
                        title="Cambiar Tipo de Factura"
                        >mdi-swap-horizontal</v-icon
                    > -->

                        <router-link
                            :to="{
                                path: `/registrar-factura-devolucion?id=${item.id}`,
                            }"
                            class="action-buttons"
                        >
                            <v-icon
                                small
                                class="mr-2"
                                color="#1d2735"
                                style="font-size: 25px"
                                title="EDITAR"
                                >mdi-pencil-outline</v-icon
                            >
                        </router-link>

                        <!-- Mostrar el botón de borrar solo si es la última fila y si no ha sido enviada al cliente aun -->
                        <v-icon
                            v-if="index === 0 && !item.enviado"
                            @click="openModal(item.id)"
                            small
                            class="mr-2"
                            color="red"
                            style="font-size: 25px"
                            title="BORRAR"
                            >mdi-trash-can</v-icon
                        >
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <!--  Cambiar año fiscal -->
        <v-dialog v-model="anio_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas cambiar el año fiscal?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="error" large @click="anio_dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="cambiar_anio()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <DeleteDialog
            v-model="dialog"
            :id="selected_id"
            @delete="deleteFactura"
        ></DeleteDialog>

        <!-- Enviar email -->
        <FacturaMailDialog
            @Sent="getFacturas()"
            v-model="mail_dialog"
            :id_factura="id_factura"
            :kit="kit_seleccionado"
            :devolucion="true"
            :email="email"
        ></FacturaMailDialog>
    </div>
</template>

<script>
import { formatPrice } from "../../../../utils/formatters";
import FilterComponentVue from "../../../../components/general/FilterComponent.vue";
import DeleteDialog from "../../../../components/general/DeleteDialog.vue";
import FacturaMailDialog from "../../componentes/FacturaMailDialog.vue";
import { debounce } from "lodash";

export default {
    components: { FilterComponentVue, DeleteDialog, FacturaMailDialog },
    name: "ListaFacturasDevolucion",
    data() {
        return {
            filtros_prueba: {
                search: "",
                cliente: { value: null },
            },
            filter_headers: [
                {
                    title: "Cliente",
                    type: "cliente",
                    active: false,
                    model: "cliente",
                    item_text: "nombre",
                    item_value: "id",
                    items: [],
                },
                {
                    title: "Fecha de creación",
                    type: "date",
                    active: true,
                    model: "fecha",
                },
                /*{
                    title: "Estado de pago",
                    type: "select",
                    active: false,
                    model: "esta_pagada",
                    item_text: "nombre",
                    item_value: "id",
                    items: [
                        {
                            id: 0,
                            nombre: "Pendiente",
                        },
                        {
                            id: 1,
                            nombre: "Pagada",
                        },
                        {
                            id: 2,
                            nombre: "Parcial (Un solo ingreso)",
                        },
                        {
                            id: 3,
                            nombre: "Parcial (Varios ingresos)",
                        },
                    ],
                },*/
            ],
            headers: [
                {
                    text: "N° Abono",
                    value: "nro_anio_factura",
                    sortable: true,
                },
                { text: "Fecha", value: "fecha", sortable: false },
                {
                    text: "Cliente",
                    value: "cliente",
                    sortable: false,
                },
                {
                    text: "Nombre fiscal",
                    value: "nombre_cliente",
                    sortable: false,
                },
                { text: "Total", value: "total", sortable: false },
                {
                    text: "Factura asociada",
                    value: "factura_asociada",
                    sortable: false,
                },
                { text: "Facturada", value: "facturada", align: "center" },
                { text: "Enviada", value: "enviado", align: "center" },

                { text: "PDF", value: "url", sortable: false },
                {
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                    align: "center",
                },
            ],
            facturas: [],
            totalFacturas: 0,
            options: {
                page: 1,
                itemsPerPage: 15,
            },
            importe_total: 0,
            dialog: false,
            kit_seleccionado: 0,
            mail_dialog: false,
            id_factura: null,
            selected_id: null,
            email: null,
            anio_dialog: false,
        };
    },
    created() {},
    methods: {
        // Acciones de facturas
        getFacturas() {
            axios
                .get(`/api/facturas/devolucion`, {
                    params: {
                        page: this.options.page,
                        itemsPerPage: this.options.itemsPerPage,
                        search: this.filtros_prueba.search,
                        cliente: this.filtros_prueba.cliente.value,
                        desde: this.filtros_prueba.fecha?.start,
                        hasta: this.filtros_prueba.fecha?.end,
                    },
                })
                .then((res) => {
                    this.facturas = res.data.data;
                    this.totalFacturas = res.data.total;
                    this.importe_total = res.data.importe;
                });
        },
        onOptionsUpdate(newOptions) {
            this.options = newOptions;

            /*if (this.options.sortBy.length > 0) {
                this.sortBy = this.options.sortBy[0];
            } else {
                this.options.sortBy = [this.sortBy];
            }
            if (this.options.sortDesc.length > 0) {
                this.sortDesc = this.options.sortDesc[0];
            } else {
                this.options.sortDesc = [!this.sortDesc];
            }*/

            this.getFacturas();
        },
        // Exportar listado de facturas
        Exportar() {
            const reqstr = this.Params();

            /*axios
                .post(
                    `api/exportar-facturas/${this.tipo}?amount=-1${reqstr}`,
                    this.filtros2,
                    {
                        responseType: "blob",
                    }
                )
                .then((res) => {
                    const url = window.URL.createObjectURL(
                        new Blob([res.data])
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "facturas.xlsx");
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((err) => {
                    console.error(err);
                });*/
        },

        // Eliminar factura
        openModal(id) {
            this.selected_id = id;
            this.dialog = true;
        },
        deleteFactura() {
            axios
                .delete(`api/facturas/devolucion/delete/${this.selected_id}`)
                .then(
                    (res) => {
                        this.$toast.sucs(res.data.message);
                        this.dialog = false;
                        this.getFacturas();
                    },
                    (err) => {
                        this.$toast.error(err.response.data.message);
                    }
                );
        },

        // Cambiar año fiscal de facturas
        CambiarAnioModal() {
            this.anio_dialog = true;
        },
        cambiar_anio() {
            axios.get("api/cambiar-anio-fiscal").then((res) => {
                this.anio_dialog = false;
                this.$toast.sucs("Año fiscal cambiado correctamente");
                this.getFacturas();
            }).catch((err) => {
                this.$toast.error("Error al cambiar el año fiscal");
            });
        },

        // Auxiliares
        formatPrice,
    },
    computed: {
        isloading: function () {
            return this.$store.getters.getloading;
        },
    },
    watch: {
        filtros_prueba: {
            deep: true,
            handler: debounce(function (n) {
                this.getFacturas();
            }, 500),
        },
    },
};
</script>
